import React, { useEffect, createContext, useState } from "react";

export const AppContext = createContext();

const AppContextProvider = (props) => {
  const [authUser, setAuthUser] = useState(false);
  const [activeMenu, setActiveMenu] = useState("home");
  const [fullPageLoading, setFullPageLoading] = useState(true);
  const [appConfig, setAppConfig] = useState({});
  const [isSiderCollapsed, setIsSiderCollapsed] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setFullPageLoading(false);
    }, 1500);
  }, []);

  const setAppConfigWrapper = (obj = {}) => {
    if (JSON.stringify(appConfig) !== JSON.stringify(obj)) {
      setAppConfig((prev) => ({ ...prev, ...obj }));
    }

    if (obj.direction === "rtl") {
      document.body.classList.add("app_rtl");
      document.body.classList.remove("app_ltr");
    } else if (obj.direction === "ltr") {
      document.body.classList.add("app_ltr");
      document.body.classList.remove("app_rtl");
    }
  };

  const roundOff = (number) => {
    let places = 8;
    if (authUser.round_off === true) {
      places = 2;
    }

    return +(Math.round(number + "e+" + places) + "e-" + places);
  };

  return (
    <AppContext.Provider
      value={{
        authUser,
        setAuthUser,
        activeMenu,
        setActiveMenu,
        fullPageLoading,
        setFullPageLoading,
        appConfig,
        setAppConfigWrapper,
        roundOff,
        isSiderCollapsed,
        setIsSiderCollapsed,
      }}
    >
      {props.children}
    </AppContext.Provider>
  );
};

export default AppContextProvider;
